module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/4.2-login.f65015d9.png";